import { IoArrowForwardSharp } from "react-icons/io5";
import {
  AiFillGithub,
  AiFillGoogleCircle,
  AiFillLinkedin,
} from "react-icons/ai";
import "./Contact.scss";
import { animateScroll as scroll } from "react-scroll";

const Contact = ({ setCursorVariant }) => {
  const objectEnter = () => {
    setCursorVariant("differ");
  };
  const objectLeave = () => {
    setCursorVariant("default");
  };

  return (
    <div className="contact-wrapper" data-scroll-section id="contact">
      <div
        className="contact-headline"
        onMouseEnter={objectEnter}
        onMouseLeave={objectLeave}
      >
        <div className="contact-outline">contact</div>
        <div className="contact-text">contact</div>
        <div className="contact-outline">contact</div>
      </div>
      <div className="contact-info">
        <div className="contact-link">
          <a href="mailto:vaibhav.dhiman.my@gmail.com">
            <span>
              <AiFillGoogleCircle />
            </span>
          </a>
          <a
            href="https://www.linkedin.com/in/v-man/"
            target="_blank"
            rel="noreferrer"
          >
            <span>
              <AiFillLinkedin />
            </span>
          </a>
          <a
            href="https://github.com/vars7899"
            target="_blank"
            rel="noreferrer"
          >
            <span>
              <AiFillGithub />
            </span>
          </a>
        </div>
        <a href="mailto:vaibhav.dhiman.my@gmail.com">
          <button className="contact-button">
            Get In Touch
            <span>
              <IoArrowForwardSharp />
            </span>
          </button>
        </a>
      </div>
    </div>
  );
};

export default Contact;
